import type { Action } from 'react-sweet-state';
import { createHook, createStore } from 'react-sweet-state';

export type IssueCreateSidePanelContextType = {
	summary?: string;
};

type State = {
	summary: string;
};

const initialIssueCreateSidePanelState: State = {
	summary: '',
};

const issueCreateSidePanelActions = {
	setSummary:
		(summary: string): Action<State> =>
		({ setState }) => {
			setState({ summary });
		},
};

const Store = createStore({
	initialState: {
		...initialIssueCreateSidePanelState,
	},
	actions: issueCreateSidePanelActions,
	name: 'issueCreateSidePanelContext',
});

export const useIssueCreateSidePanelContext = createHook(Store);
